
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8607_3191)"}},[_c('path',{attrs:{"d":"M14.742 12.5h3.308a2.998 2.998 0 002.949 2.5c1.654 0 3-1.346 3-3s-1.346-3-3-3a2.997 2.997 0 00-2.949 2.5h-3.308a4.53 4.53 0 01-3.182-1.318L9.128 7.75l1.932-1.932A4.534 4.534 0 0114.242 4.5h3.808A2.998 2.998 0 0020.999 7c1.654 0 3-1.346 3-3s-1.346-3-3-3a2.997 2.997 0 00-2.949 2.5h-3.808a5.539 5.539 0 00-3.889 1.611L8.421 7.043 5.687 4.308C5.881 3.911 6 3.471 6 3c0-1.654-1.346-3-3-3S0 1.346 0 3s1.346 3 3 3c.818 0 1.559-.331 2.101-.864L7.714 7.75 5.33 10.134A2.982 2.982 0 003 9c-1.654 0-3 1.346-3 3s1.346 3 3 3a2.98 2.98 0 002.33-1.134l2.384 2.384-2.613 2.614A2.988 2.988 0 003 18c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3c0-.471-.119-.911-.313-1.308l2.734-2.735 1.932 1.932a5.535 5.535 0 003.889 1.611h3.808a2.998 2.998 0 002.949 2.5c1.654 0 3-1.346 3-3s-1.346-3-3-3a2.997 2.997 0 00-2.949 2.5h-3.808a4.53 4.53 0 01-3.182-1.318L9.128 16.25l2.432-2.432a4.534 4.534 0 013.182-1.318zM21 10c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0-8c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM3 5c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0 18c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm18-5c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM3 14c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm5.422 1.543l-2.591-2.591C5.933 12.651 6 12.335 6 12c0-.335-.068-.651-.169-.952l2.591-2.591 2.432 2.432A5.494 5.494 0 0012.492 12a5.494 5.494 0 00-1.638 1.111l-2.432 2.432z","fill":"#000C1F"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8607_3191"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    